var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18025_34600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2833 3.71584C15.1141 2.54661 13.2184 2.54663 12.0492 3.71586L11.3842 4.38088L11.3744 4.37115L10.1959 5.54966L10.2057 5.55941L3.67226 12.093C3.09926 12.6661 2.77734 13.4432 2.77734 14.2536V16.3887C2.77734 16.6097 2.86514 16.8217 3.02142 16.978C3.1777 17.1342 3.38966 17.222 3.61068 17.222L5.74574 17.222C6.55614 17.222 7.33334 16.9001 7.90638 16.327L16.2833 7.94986C17.4525 6.78065 17.4525 4.88503 16.2833 3.71584ZM11.3842 6.73792L4.85079 13.2715C4.59033 13.532 4.44401 13.8852 4.44401 14.2536L4.44401 15.5554H5.74574C6.1141 15.5554 6.46738 15.409 6.72784 15.1486L13.2612 8.61496L11.3842 6.73792ZM14.4397 7.43643L15.1048 6.77136C15.6231 6.25303 15.6231 5.41267 15.1048 4.89434C14.5864 4.37601 13.746 4.37601 13.2277 4.89436L12.5627 5.55939L14.4397 7.43643Z",
    fill: "#002CFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18025_34600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/iconEdit.82b5f6c24d6100632e6891da7211fea8.svg";
export { ForwardRef as ReactComponent };